import { createMockApi, type ProdyApi } from './api';

/* ------------------------------------------------------------------ *
 * React components get the API from context. Module *definitions*
 * cannot — a `search` provider is a plain function called by the
 * palette outside any component tree — so there is one module-scoped
 * instance for them, set once at boot.
 *
 * Keeping this separate from the context, rather than reaching for a
 * global everywhere, is what keeps the components testable: a test
 * renders with its own API in context and never touches this.
 * ------------------------------------------------------------------ */

let instance: ProdyApi | null = null;

export const setApi = (api: ProdyApi): void => {
  instance = api;
};

export const getApi = (): ProdyApi => {
  if (!instance) instance = createMockApi();
  return instance;
};
